import * as yup from 'yup'
import { mediaSchema } from '@/components/inputs'
import { OTHER_SPECIE_OPTION_VALUE } from '../fieldsOptions'

export const schema = yup.object({
  specie: yup.string().required(),
  other_specie: yup.string().when('specie', {
    is: OTHER_SPECIE_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  amount: yup.number().required(),
  counting_method: yup.string().required(),
  behaviour_notes: yup.string().max(256),
  observed_at: yup.date().required(),
  photos: mediaSchema,
})
